// Global highlight manager to handle click-outside for all risk cards
// This replaces individual useEffect hooks for better performance

class HighlightManager {
  private activeCardRefs: Set<React.RefObject<HTMLElement>> = new Set();
  private isListening = false;

  // Register a card ref to be monitored
  registerCard(cardRef: React.RefObject<HTMLElement>) {
    this.activeCardRefs.add(cardRef);

    if (!this.isListening) {
      this.startListening();
    }
  }

  // Unregister a card ref
  unregisterCard(cardRef: React.RefObject<HTMLElement>) {
    this.activeCardRefs.delete(cardRef);

    if (this.activeCardRefs.size === 0) {
      this.stopListening();
    }
  }

  private startListening() {
    if (this.isListening) return;

    this.isListening = true;
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  private stopListening() {
    if (!this.isListening) return;

    this.isListening = false;
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  private handleClickOutside = (event: MouseEvent) => {
    // Check if click is outside all registered cards
    const isClickOutsideAllCards = Array.from(this.activeCardRefs).every(cardRef => {
      return !cardRef.current || !cardRef.current.contains(event.target as Node);
    });

    if (isClickOutsideAllCards) {
      // Remove highlights from all blocks
      document.querySelectorAll('.highlighted-block-new').forEach(el => {
        el.classList.remove('highlighted-block-new', 'highlighted-block-new-sweep');
      });
    }
  };

  // Clean up method
  cleanup() {
    this.stopListening();
    this.activeCardRefs.clear();
  }
}

// Export singleton instance
export const highlightManager = new HighlightManager();
